var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarSchedule(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1572_15443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50097 16.2024H4.86755C3.66354 16.2024 2.6875 15.2057 2.6875 13.9762V6.55553C2.6875 5.32604 3.66354 4.32934 4.86755 4.32934H13.5878C14.7918 4.32934 15.7678 5.32604 15.7678 6.55553V8.41069M6.32092 5.81347V2.84521M12.1344 5.81347V2.84521M6.32819 8.03966H6.32092M6.32819 10.2659H6.32092M6.32819 12.492H6.32092M9.23492 10.2659H9.22766M9.23492 8.03966H9.22766M12.1417 8.03966H12.1344M13.5878 12.121V13.4624L14.3144 13.9762M16.4945 13.6051C16.4945 11.7609 15.0304 10.2659 13.2244 10.2659C11.4184 10.2659 9.95434 11.7609 9.95434 13.6051C9.95434 15.4494 11.4184 16.9444 13.2244 16.9444C15.0304 16.9444 16.4945 15.4494 16.4945 13.6051Z",
    stroke: "white",
    strokeWidth: 1.06722,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1572_15443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.4404,
    height: 17.8095,
    fill: "white",
    transform: "translate(0.507812 0.619141)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSchedule);
export default __webpack_public_path__ + "static/media/calendar-schedule.cdf38e076f0f4cb07bad66075b1a7e7f.svg";
export { ForwardRef as ReactComponent };